import { apiCall } from './gqlClient';

const GENERATEPAYMENTINTENT_QUERY = `
  query generatePaymentIntent($productId: String, $reservationId: Int, $subscriptionId: Int, $email: String, $membershipId: Int, $quantity: Int, $startTime: DateTime, $firstname: String, $lastname: String, $phone: String, $wallet: JSON!, $bundleId: String) {
    generatePaymentIntent(productId: $productId, reservationId: $reservationId, subscriptionId: $subscriptionId, email: $email, membershipId: $membershipId, quantity: $quantity, startTime: $startTime, firstname: $firstname, lastname: $lastname, phone: $phone, wallet: $wallet, bundleId: $bundleId)
    {
      id
			message
			success
			amount
			amountCents
			clientSecret
			stripeAccount
			offerId
			productId
      ...fragments
    }
  }`;

export const generatePaymentIntentApiCall = async ({productId, reservationId, subscriptionId, email, membershipId, quantity, startTime, firstname, lastname, phone, wallet, bundleId}, fragments = null) => apiCall({ query: GENERATEPAYMENTINTENT_QUERY, variables: {productId, reservationId, subscriptionId, email, membershipId, quantity, startTime, firstname, lastname, phone, wallet, bundleId}, fragments });

const GENERATEWIDGETPAYMENTINTENT_QUERY = `
  query generateWidgetPaymentIntent($productId: String, $reservationId: Int, $subscriptionId: Int, $email: String, $membershipId: Int, $quantity: Int, $startTime: DateTime, $firstname: String, $lastname: String, $phone: String, $bundleId: String) {
    generateWidgetPaymentIntent(productId: $productId, reservationId: $reservationId, subscriptionId: $subscriptionId, email: $email, membershipId: $membershipId, quantity: $quantity, startTime: $startTime, firstname: $firstname, lastname: $lastname, phone: $phone, bundleId: $bundleId)
    {
      id
			message
			success
			amount
			amountCents
			clientSecret
			stripeAccount
			offerId
			productId
      ...fragments
    }
  }`;

export const generateWidgetPaymentIntentApiCall = async ({productId, reservationId, subscriptionId, email, membershipId, quantity, startTime, firstname, lastname, phone, bundleId}, fragments = null) => apiCall({ query: GENERATEWIDGETPAYMENTINTENT_QUERY, variables: {productId, reservationId, subscriptionId, email, membershipId, quantity, startTime, firstname, lastname, phone, bundleId}, fragments });

const GETORDERPAYMENTINTENT_QUERY = `
  query getOrderPaymentIntent($orderId: Int!) {
    getOrderPaymentIntent(orderId: $orderId)
    {
      id
			message
			success
			amount
			amountCents
			clientSecret
			stripeAccount
			offerId
			productId
      ...fragments
    }
  }`;

export const getOrderPaymentIntentApiCall = async ({orderId}, fragments = null) => apiCall({ query: GETORDERPAYMENTINTENT_QUERY, variables: {orderId}, fragments });

const GETMYSETUPINTENTSFORPROVIDER_QUERY = `
  query getMySetupIntentsForProvider($providerId: Int!) {
    getMySetupIntentsForProvider(providerId: $providerId)
  }`;

export const getMySetupIntentsForProviderApiCall = async ({providerId}, ) => apiCall({ query: GETMYSETUPINTENTSFORPROVIDER_QUERY, variables: {providerId}});

const GETMYPAYMENTMETHODSFORPROVIDER_QUERY = `
  query getMyPaymentMethodsForProvider($providerId: Int!) {
    getMyPaymentMethodsForProvider(providerId: $providerId)
    {
      id
      ...fragments
    }
  }`;

export const getMyPaymentMethodsForProviderApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETMYPAYMENTMETHODSFORPROVIDER_QUERY, variables: {providerId}, fragments });

const GETCUSTOMERSPAYMENTPROVIDERS_QUERY = `
  query getCustomersPaymentProviders {
    getCustomersPaymentProviders
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getCustomersPaymentProvidersApiCall = async (fragments = null) => apiCall({ query: GETCUSTOMERSPAYMENTPROVIDERS_QUERY, variables: {}, fragments });

const CREATESETUPINTENTFORPROVIDER_QUERY = `
  mutation createSetupIntentForProvider($providerId: Int!, $paymentMethod: String!) {
    createSetupIntentForProvider(providerId: $providerId, paymentMethod: $paymentMethod)
    {
      id
			message
			success
			clientSecret
			stripeAccount
      ...fragments
    }
  }`;

export const createSetupIntentForProviderApiCall = async ({providerId, paymentMethod}, fragments = null) => apiCall({ query: CREATESETUPINTENTFORPROVIDER_QUERY, variables: {providerId, paymentMethod}, fragments });

const DELETEPAYMENTMETHOD_QUERY = `
  mutation deletePaymentMethod($providerId: Int!, $paymentMethod: String!) {
    deletePaymentMethod(providerId: $providerId, paymentMethod: $paymentMethod)
    {
      success
			message
			id
			name
      ...fragments
    }
  }`;

export const deletePaymentMethodApiCall = async ({providerId, paymentMethod}, fragments = null) => apiCall({ query: DELETEPAYMENTMETHOD_QUERY, variables: {providerId, paymentMethod}, fragments });

const CREATESTRIPECUSTOMER_QUERY = `
  mutation createStripeCustomer {
    createStripeCustomer
    {
      success
			message
			id
			name
      ...fragments
    }
  }`;

export const createStripeCustomerApiCall = async (fragments = null) => apiCall({ query: CREATESTRIPECUSTOMER_QUERY, variables: {}, fragments });

const GENERATEB2BSUBSCRIPTION_QUERY = `
  mutation generateB2bSubscription($paymentMethodId: String!, $customerId: String!, $planId: String!, $promoCode: String) {
    generateB2bSubscription(paymentMethodId: $paymentMethodId, customerId: $customerId, planId: $planId, promoCode: $promoCode)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const generateB2bSubscriptionApiCall = async ({paymentMethodId, customerId, planId, promoCode}, fragments = null) => apiCall({ query: GENERATEB2BSUBSCRIPTION_QUERY, variables: {paymentMethodId, customerId, planId, promoCode}, fragments });

const CANCELB2BSUBSCRIPTION_QUERY = `
  mutation cancelB2bSubscription {
    cancelB2bSubscription
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const cancelB2bSubscriptionApiCall = async (fragments = null) => apiCall({ query: CANCELB2BSUBSCRIPTION_QUERY, variables: {}, fragments });

const LINKCONNECTEDPAYMENTACCOUNT_QUERY = `
  mutation linkConnectedPaymentAccount($code: String!) {
    linkConnectedPaymentAccount(code: $code)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const linkConnectedPaymentAccountApiCall = async ({code}, fragments = null) => apiCall({ query: LINKCONNECTEDPAYMENTACCOUNT_QUERY, variables: {code}, fragments });

const UNLINKCONNECTEDPAYMENTACCOUNT_QUERY = `
  mutation unlinkConnectedPaymentAccount {
    unlinkConnectedPaymentAccount
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const unlinkConnectedPaymentAccountApiCall = async (fragments = null) => apiCall({ query: UNLINKCONNECTEDPAYMENTACCOUNT_QUERY, variables: {}, fragments });

const SAVEPAYMENTGATEWAYCUSTOMER_QUERY = `
  mutation savePaymentGatewayCustomer($request: PaymentGatewayCustomerInput!) {
    savePaymentGatewayCustomer(request: $request)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const savePaymentGatewayCustomerApiCall = async ({request}, fragments = null) => apiCall({ query: SAVEPAYMENTGATEWAYCUSTOMER_QUERY, variables: {request}, fragments });

const VALIDATEPROMOCODE_QUERY = `
  mutation validatePromoCode($promoCode: String!, $planId: String!) {
    validatePromoCode(promoCode: $promoCode, planId: $planId)
    {
      promoCode
			isValid
			duration
			durationInMonths
			fixedDiscount
			percentDiscount
			total
			totalWithDiscount
      ...fragments
    }
  }`;

export const validatePromoCodeApiCall = async ({promoCode, planId}, fragments = null) => apiCall({ query: VALIDATEPROMOCODE_QUERY, variables: {promoCode, planId}, fragments });

const UPDATESUBSCRIPTIONPROMOCODE_QUERY = `
  mutation updateSubscriptionPromoCode($promoCode: String!) {
    updateSubscriptionPromoCode(promoCode: $promoCode)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const updateSubscriptionPromoCodeApiCall = async ({promoCode}, fragments = null) => apiCall({ query: UPDATESUBSCRIPTIONPROMOCODE_QUERY, variables: {promoCode}, fragments });

const CHANGEB2BSUBSCRIPTIONPLAN_QUERY = `
  mutation changeB2bSubscriptionPlan($planId: String!) {
    changeB2bSubscriptionPlan(planId: $planId)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const changeB2bSubscriptionPlanApiCall = async ({planId}, fragments = null) => apiCall({ query: CHANGEB2BSUBSCRIPTIONPLAN_QUERY, variables: {planId}, fragments });

const SWEEPOVERDUEINSTALLMENTSFORDUNNING_QUERY = `
  mutation sweepOverdueInstallmentsForDunning {
    sweepOverdueInstallmentsForDunning
    {
      swept
      ...fragments
    }
  }`;

export const sweepOverdueInstallmentsForDunningApiCall = async (fragments = null) => apiCall({ query: SWEEPOVERDUEINSTALLMENTSFORDUNNING_QUERY, variables: {}, fragments });

const DRAINPAYMENTOUTBOX_QUERY = `
  mutation drainPaymentOutbox($limit: JSON!) {
    drainPaymentOutbox(limit: $limit)
    {
      processed
			failed
      ...fragments
    }
  }`;

export const drainPaymentOutboxApiCall = async ({limit}, fragments = null) => apiCall({ query: DRAINPAYMENTOUTBOX_QUERY, variables: {limit}, fragments });

const PROCESSDUEBUNDLERENEWALS_QUERY = `
  mutation processDueBundleRenewals($limit: Int!) {
    processDueBundleRenewals(limit: $limit)
    {
      due
			charged
			failed
      ...fragments
    }
  }`;

export const processDueBundleRenewalsApiCall = async ({limit}, fragments = null) => apiCall({ query: PROCESSDUEBUNDLERENEWALS_QUERY, variables: {limit}, fragments });
